const useRandomHexaColorGenerator = () => {
  function randomColorUtility (length) {
    return Math.floor(Math.random() * length);
  }

  const getColor = () => {
    const hex = [1, 2, 3, 4, 5, 6, 7, 8, 9, "A", "B", "C", "D", "E", "F"];
    let hexColor = "#";
    for (let i = 0; i < 6; i++) {
      hexColor += hex[randomColorUtility(hex.length)];
    }
    return hexColor
  }

  return getColor;
}

export default useRandomHexaColorGenerator